// Sprint 19 A2: Hook for deal risk radar
import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "@/lib/api-client";

export interface DealRiskAssessment {
  dealId: string;
  dealTitle: string;
  valueCents: number;
  currency: string;
  riskScore: number;
  riskLevel: "critical" | "high" | "medium" | "low";
  factors: Array<{ factor: string; severity: string; description: string; points: number }>;
  recommendations: Array<{ action: string; urgency: string; reasoning: string; aiGenerated: boolean }>;
  priorityScore: number;
  aiGenerated: boolean;
}

export function useRiskRadar() {
  const [data, setData] = useState<DealRiskAssessment[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    apiFetch<{ data: DealRiskAssessment[] }>("/crm/intelligence/deals/risk-radar")
      .then((res) => setData(res.data))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load"))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
}
